import { FormControl, InputAdornment, OutlinedInput, Grid, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useState, useEffect, useCallback } from "react";

const OwnHome = ({ page, setPage, formData, setFormData }) => {
    const [ownsHome, setOwnsHome] = useState(false);
    const [ownHomeError, setOwnHomeError] = useState(null);
    const [propertyValueError, setPropertyValueError] = useState(null);
    const [propertyMortgageError, setPropertyMortgageError] = useState(null);

    const onOwnHomeChange = (e) => {
        setFormData({ ...formData, ownHome: e.target.value });
    };
    const onPropertyValueChange = (e) => {
        if (e.target.value.length > 8) {
            e.preventDefault();
        } else {
            setFormData({ ...formData, propertyValue: parseInt(e.target.value, 10) });
        }
        setPropertyValueError(null);
    }
    const onPropertyMortgageChange = (e) => {
        if (e.target.value.length > 8) {
            e.preventDefault();
        } else {
            setFormData({ ...formData, propertyMortgage: parseInt(e.target.value, 10) });
        }
        setPropertyMortgageError(null);
    }

    const clearUnusedFields = () => {
        setFormData({ ...formData, propertyValue: "", propertyMortgage: "" });
    }

    const preventPaste = (e) => {
        e.preventDefault();
    };

    const updateFormData = useCallback(() => {
        setFormData(formData);
        if (formData.ownHome === 'yes') {
            setOwnsHome(true);
        } else {
            setOwnsHome(false);
        }
    }, [formData, setFormData]);

    useEffect(() => {
        updateFormData();
    }, [updateFormData]);

    useEffect(() => {
        setOwnHomeError(null);
        setPropertyValueError(null);
        setPropertyMortgageError(null);
    }, [formData.lang]);

    const validateData = () => {
        var valid = true;
        if (formData.ownHome === "yes") {
            if (formData.propertyValue === "" || isNaN(formData.propertyValue)) {
                setPropertyValueError(formData.lang === "fr" ? "Veuillez entrer un numéro" : "Please enter a numerical value");
                valid = false;
            } else {
                setPropertyValueError(null);
            }

            if (formData.propertyMortgage === "" || isNaN(formData.propertyMortgage)) {
                setPropertyMortgageError(formData.lang === "fr" ? "Veuillez entrer un numéro" : "Please enter a numerical value");
                valid = false;
            } else {
                setPropertyMortgageError(null);
            }

            if (valid) {
                window.dataLayer.push({'event': 'loan_step8', 'loanEvent': 'step8', 'loanEventID': 9});
                // quebec only
                // window.dataLayer.push({'event': 'loan_step8q', 'loanEvent': 'step8q', 'loanEventID': '9q'});
                setPage(page + 1);
            }
        } else if (formData.ownHome === "no") {
            setPropertyValueError(null);
            setPropertyMortgageError(null);
            setOwnHomeError(null);
            clearUnusedFields();

            window.dataLayer.push({'event': 'loan_step8', 'loanEvent': 'step8', 'loanEventID': 9});
            // quebec only
            // window.dataLayer.push({'event': 'loan_step8q', 'loanEvent': 'step8q', 'loanEventID': '9q'});
            
            setPage(page + 1);
        } else {
            setOwnHomeError(formData.lang === "fr" ? "Ceci est nécessaire" : "This option is required");
            valid = false;
        }
    }

    return (
        <div className="card">
            <div className="card-div">
                <div className="textfield-label">{formData.lang === "fr" ? "Êtes-vous propriétaire d'un logement?" : "Do you own a home?"}</div>
                <ToggleButtonGroup
                    value={formData.ownHome}
                    exclusive
                    onChange={(e) => onOwnHomeChange(e)}>
                    <ToggleButton value="yes">
                        {formData.lang === "fr" ? "Oui" : "Yes"}
                    </ToggleButton>
                    <ToggleButton value="no">
                        {formData.lang === "fr" ? "Non" : "No"}
                    </ToggleButton>
                </ToggleButtonGroup>
                <div className="error-text">{ownHomeError}</div>
                {ownsHome ?
                    <div>
                        <div className="textfield-label">{formData.lang === "fr" ? "Valeur de la propriété" : "Value of the Property"}</div>
                        <FormControl fullWidth>
                            <OutlinedInput
                                type="number"
                                startAdornment={
                                    <div className="custom-start-adornment-div">
                                        <InputAdornment style={{ marginLeft: 10 }} position="start">$</InputAdornment>
                                    </div>
                                }
                                endAdornment={
                                    <div className="custom-end-adornment-div">
                                        <InputAdornment style={{ marginRight: 10 }} position="end">.00</InputAdornment>
                                    </div>
                                }
                                value={formData.propertyValue}
                                onPaste={preventPaste}
                                onKeyDown={e => (e.key === "e" || e.key === "." || e.code === 'Minus' || e.code === 'ArrowUp' || e.code === 'ArrowDown') && e.preventDefault()}
                                onWheel={(e) => e.target.blur()}
                                onChange={onPropertyValueChange}
                            />
                        </FormControl>
                        <div className="error-text">{propertyValueError}</div>
                        <div className="textfield-label">{formData.lang === "fr" ? "Montant de l'hypothèque" : "Mortgage Amount"}</div>
                        <FormControl fullWidth>
                            <OutlinedInput
                                type="number"
                                startAdornment={
                                    <div className="custom-start-adornment-div">
                                        <InputAdornment style={{ marginLeft: 10 }} position="start">$</InputAdornment>
                                    </div>
                                }
                                endAdornment={
                                    <div className="custom-end-adornment-div">
                                        <InputAdornment style={{ marginRight: 10 }} position="end">.00</InputAdornment>
                                    </div>
                                }
                                value={formData.propertyMortgage}
                                onPaste={preventPaste}
                                onKeyDown={e => (e.key === "e" || e.key === "." || e.code === 'Minus' || e.code === 'ArrowUp' || e.code === 'ArrowDown') && e.preventDefault()}
                                onWheel={(e) => e.target.blur()}
                                onChange={onPropertyMortgageChange}
                            />
                        </FormControl>
                        <div className="error-text">{propertyMortgageError}</div>
                    </div> : null}

                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <button className="nav-button"
                            onClick={() => {
                                setPage(page - 1);
                            }}>
                            {formData.lang === "fr" ? "Précédent" : "Previous"}
                        </button>
                    </Grid>
                    <Grid item xs={6}>
                        <button className="nav-button"
                            onClick={() => {
                                validateData();
                            }}>
                            {formData.lang === "fr" ? "Suivant" : "Next"}
                        </button>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default OwnHome;